import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Table, Button, Badge } from "react-bootstrap";
import { toast } from "react-toastify";
import { authFetch } from "../utils/authFetch";

export default function ClientOrderSummaryTable({items, currentPage, itemsPerPage, formatDateRo, appVariant}) {
  const navigate = useNavigate();
  const [opening, setOpening] = useState(null);
  const createEstimate = async order => {
    setOpening(order.bxid);
    try {
      const estimate = await authFetch(`/comenzi/client/${order.bxid}/genereaza-deviz`, { method: 'POST' });
      navigate(`/comenzi/intern/linii?open=${estimate.bxid}`);
    } catch (error) {
      toast.error(error.message || 'Nu s-a putut deschide devizul.');
    } finally {
      setOpening(null);
    }
  };
  return <Table hover striped bordered className="align-middle mb-0" size="sm">
    <thead className="table-dark"><tr><th>Nr.</th><th>Comandă</th><th>Data</th><th>Client</th>
      <th>Poziții</th><th>Stare comandă</th><th>Status poziții</th><th>Valuta</th><th className="text-end">Valoare fără TVA</th><th>Deviz</th></tr></thead>
    <tbody>{items.map((order,index) => <tr key={order.bxid}>
      <td>{currentPage * itemsPerPage + index + 1}</td>
      <td><Link to={`/comenzi/client/edit/${order.bxid}`}>{order.bxnumar_comanda || order.bxid}</Link></td>
      <td>{formatDateRo(order.bxdata_comanda)}</td><td>{order.customer_name || "-"}</td>
      <td>{order.line_count}</td><td><Badge bg={order.bxdatafin ? "success" : "secondary"}>{order.bxdatafin ? "Închisă" : "Deschisă"}</Badge>{order.bxdatafin && <small className="d-block">{formatDateRo(order.bxdatafin)}</small>}</td><td>{order.status_labels || "-"}</td><td>{order.valuta_code || "-"}</td>
      <td className="text-end">{Number(order.net_total || 0).toFixed(2)}</td>
      <td>{order.deviz_ids?.length ? order.deviz_ids.map(id => (
        <Link key={id} className="btn btn-outline-primary btn-sm me-1" to={`/comenzi/intern/linii?open=${id}`}>
          {order.deviz_ids.length === 1 ? 'Deschide deviz' : `Deviz #${id}`}
        </Link>
      )) : appVariant === 'SERVICE_AUTO' ? (
        <Button size="sm" variant="success" disabled={opening !== null || Boolean(order.bxdatafin)} onClick={() => createEstimate(order)}>
          {opening === order.bxid ? 'Se deschide…' : 'Creează deviz'}
        </Button>
      ) : '—'}</td>
    </tr>)}{!items.length && <tr><td colSpan={10} className="text-center py-4">Nu s-au găsit comenzi.</td></tr>}</tbody>
  </Table>;
}
